<template>
  <TransitionFromTop>
    <div :class="[style.teethAnswer, mobileVersion ? style.mobile : '']">
      <div :key="'header'" :class="style.header">
        <img src="$images/selectDental.svg" alt="" />
        <p>
          Выберите зубы которые планируете заменить, если затрудняетесь
          ответить, пропустите вопрос
        </p>
      </div>

      <div :key="'bothJaws'" :class="style.bothJaws">
        <div :class="style.selectJaw">
          <div :class="style.maxilla">
            <transition-group name="fade" tag="div">
              <img
                v-for="(obj, index) in maxilla"
                :key="'maxilla-' + index"
                @mouseover="hoverToothList['maxilla'] = index"
                @mouseleave="hoverToothList['maxilla'] = null"
                @click="chooseTooth(index, 'maxilla')"
                :style="{top: obj.top, left: obj.left}"
                :src="getDentalImg(index, 'maxilla')"
                :class="getClassDental(index, 'maxilla')"
              />
            </transition-group>
          </div>

          <div :class="style.answer" :key="'upperJaw'">
            <input name="dental" :id="dentalVariants[0]" type="checkbox" />
            <label :class="style.answerImg" :for="dentalVariants[0]">
              <div :class="style.content">
                <span :class="style.fakeBefore" />
                <span
                  v-text="dentalVariants[0]"
                  :class="style.textContent"
                ></span>
              </div>
            </label>
          </div>
        </div>

        <div :class="style.selectJaw">
          <div :class="style.mandible">
            <transition-group name="fade" tag="div">
              <img
                v-for="(obj, index) in mandible"
                :key="'mandible-' + index"
                @mouseover="hoverToothList['mandible'] = index"
                @mouseleave="hoverToothList['mandible'] = null"
                @click="chooseTooth(index, 'mandible')"
                :style="{top: obj.top, left: obj.left}"
                :src="getDentalImg(index, 'mandible')"
                :class="getClassDental(index, 'mandible')"
              />
            </transition-group>
          </div>

          <div :class="style.answer" :key="'lowerJaw'">
            <input name="dental" :id="dentalVariants[1]" type="checkbox" />
            <label :class="style.answerImg" :for="dentalVariants[1]">
              <div :class="style.content">
                <span :class="style.fakeBefore" />
                <span
                  v-text="dentalVariants[1]"
                  :class="style.textContent"
                ></span>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div key="consultation" :class="style.bottomButton">
        <div :class="style.answer">
          <input name="dental" :id="dentalVariants[2]" type="checkbox" />
          <label :class="style.answerImg" :for="dentalVariants[2]">
            <div :class="style.content">
              <span
                :style="{borderRadius: '50% !important'}"
                :class="style.fakeBefore"
              />
              <span
                v-text="dentalVariants[2]"
                :class="style.textContent"
              ></span>
            </div>
          </label>
        </div>
      </div>
    </div>
  </TransitionFromTop>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./TeethAnswer.module.scss";
import maxilla from "$images/maxilla/dental";
import mandible from "$images/mandible/dental";
import TransitionFromTop from "@/dynamics/transitions/TransitionFromTop/TransitionFromTop.vue";
import {chooseToothList, hoverToothList} from "@/page/quiz/typeQuiz";

export default defineComponent({
  name: "TeethAnswer",
  components: {TransitionFromTop},
  data() {
    return {
      style,
      hoverToothList: {
        maxilla: null,
        mandible: null
      } as hoverToothList,
      maxilla,
      dentalVariants: [
        "Вся верхняя челюсть",
        "Вся нижняя челюсть",
        "Затрудняюсь ответить, нужна консультация"
      ],
      mandible,
      chooseToothList: {
        maxilla: [],
        mandible: []
      } as chooseToothList
    };
  },
  methods: {
    getDentalImg(i: number, name: string) {
      let data = name == "maxilla" ? this.maxilla : this.mandible;
      const {imgActive, imgHover, img} = data[i];
      if (this.chooseToothList[name].includes(i)) {
        return imgActive;
      }
      if (this.hoverToothList[name] == i) {
        return imgHover;
      }
      return img;
    },
    chooseTooth(i: number, name: string) {
      const index = this.chooseToothList[name].indexOf(i);
      if (index == -1) {
        this.chooseToothList[name].push(i);
      } else {
        this.chooseToothList[name].splice(index, 1);
      }
    },
    getClassDental(index: number, name: string) {
      let data = name == "maxilla" ? this.maxilla : this.mandible;
      if (data[index].class.indexOf("dental") > -1) {
        let classDental = this.style.dental;
        if (this.chooseToothList[index]) {
          classDental += " " + style.active;
        }
        return classDental;
      }
      return this.style[data[index].class];
    }
  },
  computed: {
    selectedVersion() {
      return this.$quizStore.getSelectedVersion;
    },
    mobileVersion() {
      return this.selectedVersion === "Мобильная";
    }
  }
});
</script>
